import React from 'react';
import { LabelStatus, StatusContainer } from '../styles';

export type StatusAccountProps = {
  status: string;
  statusColor: string;
  children?: React.ReactNode;
};

const StatusAccount = ({
  status,
  statusColor,
  children,
}: StatusAccountProps) => {
  return (
    <StatusContainer>
      <p>
        <LabelStatus statusColor={statusColor}>
          {status}
          {children && ' - '}
        </LabelStatus>
        {children}
      </p>
    </StatusContainer>
  );
};

export default StatusAccount;
